import { Box } from '@mui/material';

import { BillingContact } from '@/models/Contact';
import { ADFPaymentRequest } from '@/models/Payment';

import BillingContactForm from './BillingContactForm';
import CardConnectTokenizer from './CardConnectTokenizer';

function CreditCardPayment({
  paymentRequest,
  onChange,
  submitted,
}: {
  paymentRequest: ADFPaymentRequest;
  onChange: (paymentRequest: ADFPaymentRequest) => void;
  submitted: boolean;
}) {
  const handleCardTokenized = (token: string, expiry: string) => {
    const updatedPaymentRequest = {
      ...paymentRequest,
      creditCardToken: token,
      creditCardExpirationDate: expiry,
    };
    onChange(updatedPaymentRequest);
  };

  const handleBillingContactChanged = (updatedContact: BillingContact) => {
    const updatedPaymentRequest = {
      ...paymentRequest,
      billingContact: updatedContact,
    };
    onChange(updatedPaymentRequest);
  };

  return (
    <Box>
      <CardConnectTokenizer tokenized={handleCardTokenized} />
      <BillingContactForm
        contact={paymentRequest.billingContact}
        onChange={handleBillingContactChanged}
        submitted={submitted}
      />
    </Box>
  );
}

export default CreditCardPayment;
